export default "__VITE_ASSET__Qdmb1QYv__"